import React, { Component } from "react";
import { graphql, compose } from "react-apollo";
import _ from "lodash";
import "./styles/switch.css";
import "./styles/loader.css";

//Helpers
import DeleteBtn from "../../../helpers/DeleteBtn";

// Query
import query from "../../../queries/fetchSurveyById";

// Mutation
import deleteFieldCollection from "../../../mutations/deleteFieldCollection";
import addParameterizationFields from "../../../mutations/addParameterizationFields";

// Components
import FieldCollection from "./FieldCollection";
import Parameterization from "./Parameterization";
import EditBody from "./EditBody";

class EditSurveyFields extends Component {
  constructor(props) {
    super(props);
    this.state = {
      confirmDelete: null,
      deleting: false
    };
    this.parentRefetchCallback = this.parentRefetchCallback.bind(this);
    this.parentStateCallback = this.parentStateCallback.bind(this);
  }
  parentRefetchCallback() {
    this.props.data.refetch();
  }
  parentStateCallback(payload) {
    // remove empty values for avoiding graphql issues
    const cleanResults = _.pickBy(payload, _.identity);
    this.props
      .addParameterizationFields({
        variables: {
          id: this.props.match.params.id,
          ...cleanResults
        }
      })
      .then(() => this.props.data.refetch());
  }
  handleCollectionDelete(id) {
    this.props
      .deleteFieldCollection({ variables: { id } })
      .then(() => this.props.data.refetch())
      .then(() =>
        this.setState({
          deleting: false
        })
      );
  }
  renderAddedFields(fieldcollection) {
    return (
      <table className="table table-striped mb-5">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">Pregunta</th>
            <th scope="col">Tipo</th>
            <th scope="col">Alternativas de respuestas</th>
            <th scope="col" />
          </tr>
        </thead>
        <tbody>
          {_.map(fieldcollection, ({ id, type, question, answers }, i) => {
            function typeOutput() {
              if (type === "open-question") {
                return "Pregunta abierta";
              } else if (type === "single-choice") {
                return "Seleccion única";
              } else if (type === "multiple-choice") {
                return "Seleccion múltiple";
              } else if (type === "mixed-question") {
                return "Pregunta mixta";
              }
              return null;
            }
            return (
              <tr key={i}>
                <th scope="row">{i + 1}</th>
                <td>
                  <a href={`pregunta/${id}`}>{question}</a>
                </td>
                <td>{typeOutput()}</td>
                <td>{answers.length}</td>
                <td>
                  <DeleteBtn
                    deleting={this.state.deleting}
                    confirmDelete={this.state.confirmDelete}
                    id={id}
                    handleDelete={() => {
                      this.setState({
                        deleting: true
                      });
                      this.handleCollectionDelete(id);
                    }}
                    onClick={() => {
                      this.setState({
                        confirmDelete: id
                      });
                    }}
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  }
  render() {
    if (this.props.data.loading) {
      return <div className="loader">Loading...</div>;
    }
    if (this.props.data.surveyById) {
      const { fieldcollection } = this.props.data.surveyById;

      return (
        <div className="container">
          <EditBody
            survey={this.props.data.surveyById}
            parentRefetchCallback={this.parentRefetchCallback}
          />
          <div>
            <p>
              <button
                className="btn btn-info"
                type="button"
                data-toggle="collapse"
                data-target="#collapseExample"
                aria-expanded="false"
                aria-controls="collapseExample"
              >
                Parametrización
              </button>
            </p>
            <div className="collapse mb-4" id="collapseExample">
              <Parameterization
                parameterization={this.props.data.surveyById.parameterization}
                parentStateCallback={this.parentStateCallback}
              />
            </div>
          </div>

          {this.renderAddedFields(fieldcollection)}

          <hr />

          <FieldCollection surveyId={this.props.match.params.id} />
        </div>
      );
    }
    return null;
  }
}

const SurveyFieldsMutations = compose(
  graphql(deleteFieldCollection, {
    name: "deleteFieldCollection"
  }),
  graphql(addParameterizationFields, {
    name: "addParameterizationFields"
  })
);

export default SurveyFieldsMutations(
  graphql(query, {
    options: props => {
      return { variables: { id: props.match.params.id } };
    }
  })(EditSurveyFields)
);



// WEBPACK FOOTER //
// ./src/components/Survey/admin/EditSurveyFields.js